// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"02386692","85":"7344ce3a","94":"60724c42","269":"91c09bc6","369":"75322923","437":"1ef21555","453":"6174a265","690":"cf97621e","713":"7139d28a"}[chunkId] + ".chunk.js";
};